import { ReactElement, useMemo } from 'react';
import {
  sortEmirMancoSectionSummaries,
  type EmirMancoSectionSummary,
} from '../../../../../../api/rs-hg/emir';
import IndividualPie from '../IndividualPie/individualPie.component';

interface MancoSectionSummariesPiesProps {
  sections: EmirMancoSectionSummary[];
  /** When set (e.g. ``Object.keys(manco_limits)``), pies follow this order. */
  sectionOrder?: readonly string[];
  selectedKey: string;
  setSelectedKeyFunction: (key: string) => void;
}

/** Renders manco pass/fail pies from backend `manco_section_summaries`. */
function MancoSectionSummariesPies({
  sections,
  sectionOrder,
  selectedKey,
  setSelectedKeyFunction,
}: MancoSectionSummariesPiesProps): ReactElement {
  const orderedSections = useMemo(
    () => sortEmirMancoSectionSummaries(sections, sectionOrder),
    [sections, sectionOrder],
  );

  return (
    <>
      {orderedSections
        .filter((section) => section.pass + section.fail > 0)
        .map((section) => (
          <IndividualPie
            key={section.key}
            section={section}
            isSelectedKey={selectedKey === section.key}
            handlePieClick={() => setSelectedKeyFunction(section.key)}
          />
        ))}
    </>
  );
}

export default MancoSectionSummariesPies;
